import Vue from "vue";
import App from "./App.vue";

import "./icons";
import store from "./store";
import router from "./router";

import Ionic from "@ionic/vue";

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

import axios from 'axios';
import VueAxios from 'vue-axios';

import vueSignature from "vue-signature";
import * as VueGoogleMaps from "vue2-google-maps";

import { defineCustomElements } from "@ionic/pwa-elements/loader";

import User from './models/User';

Vue.use(Ionic);
Vue.use(vueSignature);
Vue.use(VueAxios, axios);
Vue.use(require('vue-moment'));
Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_API_KEY,
        libraries: "places"
    }
});

Vue.component("google-map", VueGoogleMaps.Map);
Vue.component("google-marker", VueGoogleMaps.Marker);

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ion-/];

var app = null;
firebase.initializeApp({
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID
});
firebase.auth().onAuthStateChanged(user => {
  if (app == null) {
    app = new Vue({
      store: store,
      router: router,
      async beforeCreate() {
        let user = await User.current();
        this.$store.commit("setUser", user);
        this.$mount("#app");
      },
      render: h => h(App)
    });
  }
});

defineCustomElements(window);